const { clientQuery } = require('../queries');
const { CUSTOM_QUERIES } = require('../../../../constants/customQueries.js');
const storesQuery = require('../../queries/stores/storesQuery');
const handleCtApiError = require('../handleCtApiError');

/** @import {CustomQuery, StoresData, StoresWhereSearch} from '~/types/commercetools' */

const buildStoresWhere = (search) => {
  const predicates = [];
  if (search?.key) {
    predicates.push(`key="${search.key}"`);
  }
  if (search?.id) {
    predicates.push(`id="${search.id}"`);
  }
  if (search?.ids) {
    predicates.push(`id in ("${search.ids.join('","')}")`);
  }
  return predicates.join(' and ') || null;
};

/**
 * @param {Context} context
 * @param {StoresWhereSearch} params
 * @param {Maybe<CustomQuery>} customQuery
 * @returns {{data: StoresData | null}}
 */
const getStores = async (context, params, customQuery) => {
  if (!params) {
    params = {};
  }
  const { locale } = context.config;
  const defaultVariables = {
    where: buildStoresWhere(params),
    limit: params.limit,
    offset: params.offset,
    sort: params.sort,
    locale,
  };

  const { stores } = context.extendQuery(customQuery, {
    stores: storesQuery[CUSTOM_QUERIES.STORES.stores]({
      variables: defaultVariables,
    }),
  });

  try {
    const response = await clientQuery(context, {
      query: stores.query,
      variables: stores.variables,
    });

    return response ?? null;
  } catch (error) {
    throw handleCtApiError(error);
  }
};

module.exports = getStores;
